module.exports = __webpack_public_path__ + "static/media/9_shape_r.973388cf.webp";